export const TIFFANY_MAX_SPEECH_CHARACTERS = 1200;
export const MAX_DEMO_FILE_COUNT = 3;
export const MAX_DEMO_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_TEXT_FILE_CHARACTERS = 12000;

export const DEMO_FILE_ACCEPT = [
    '.pdf',
    '.png',
    '.jpg',
    '.jpeg',
    '.webp',
    '.txt',
    '.csv',
    '.json',
    '.xml',
    '.md',
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/webp',
    'text/plain',
    'text/csv',
    'application/json',
    'application/xml',
    'text/xml',
    'text/markdown'
].join(',');

export const textUploadMimeTypes = new Set([
    'text/plain',
    'text/csv',
    'application/csv',
    'application/json',
    'application/xml',
    'text/xml',
    'text/markdown'
]);

export const binaryUploadMimeTypes = new Set([
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/webp'
]);

export const uploadMimeByExtension = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    txt: 'text/plain',
    csv: 'text/csv',
    json: 'application/json',
    xml: 'application/xml',
    md: 'text/markdown'
};